import fp from 'lodash/fp';

export const taskSelector = fp.get('task.task');
export const taskCountSelector = fp.get('task.taskCount');
export const tasksSelector = fp.get('task.tasks');
export const teamTaskSelector = fp.get('task.teamTasks');
export const businessTaskSelector = fp.get('task.businessTasks');
export const userTaskHistorySelector = fp.get('task.history');
export const getBusinessEmailJobStatusesSelector = fp.get(
  'task.businessEmailJobStatuses'
);
export const skippedTeamTaskUserReassessmentSelector = fp.get(
  'task.skippedTeamTaskUserReassessment'
);
export const skippedBusinessTaskUserReassessmentSelector = fp.get(
  'task.skippedBusinessTaskUserReassessment'
);



// WEBPACK FOOTER //
// ./src/state/modules/task/selectors.js